
import { Button, Segment, Table, Input, Select } from 'semantic-ui-react';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ageOptions, genderOptions, ethnicityOptions } from '../../components/influencer-form/influencer-form-options';
import { updateDemographics } from './utils';

class ProfileDemographics extends React.Component {
  constructor(props) {
    super(props);
    const { influencer: { gender, ageBracket, ethnicity } } = props;
    this.state = {
      gender,
      ageBracket,
      ethnicity,
      editing: false,
    };
  }


  handleSubmit = () => {
    const { gender, ageBracket, ethnicity } = this.state;
    const { influencer } = this.props;

    updateDemographics(influencer.id, { gender, ageBracket, ethnicity });
    this.setState({ editing: false });
  }

  reset = () => {
    const { influencer: { gender, ageBracket, ethnicity } } = this.props;
    this.setState({
      gender,
      ageBracket,
      ethnicity,
      editing: false,
    });
  }

  handleInputChange=(e, v) => {
    this.setState({ [v.name]: v.value });
  }
  render() {
    const { gender, ageBracket, ethnicity, editing } = this.state;

    return (<Segment padded>
      <h3>Demographics</h3>
      <Table basic="very">
        <Table.Body>
          <Table.Row>
            <Table.Cell collapsing>
              <p>Age bracket</p>
            </Table.Cell>
            <Table.Cell>
              <InputSelect
                name="ageBracket"
                value={ageBracket}
                editing={editing}
                options={ageOptions}
                placeholder="Select age group"
                onChange={this.handleInputChange}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell collapsing>
              <p>Gender</p>
            </Table.Cell>
            <Table.Cell>
              <InputSelect
                name="gender"
                value={gender}
                editing={editing}
                options={genderOptions}
                placeholder="Select gender"
                onChange={this.handleInputChange}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell collapsing>
              <p>Ethnicity</p>
            </Table.Cell>
            <Table.Cell>
              <InputSelect
                name="ethnicity"
                value={ethnicity}
                editing={editing}
                options={ethnicityOptions}
                placeholder="Select ethnicity"
                onChange={this.handleInputChange}
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      { editing ?
        <div className="flex">
          <div className="space">
            <div className="spacer small" />
            <Button size="medium" basic fluid onClick={this.reset}>Cancel</Button>
          </div>
          <div className="space">
            <div className="spacer small" />
            <Button size="medium" color="pink" fluid onClick={this.handleSubmit}>Save Changes</Button>
          </div>
        </div>
        :
        <div className="flex">
          <div className="space">
            <div className="spacer small" />
            <Button
              size="medium"
              basic fluid onClick={() => this.setState({ editing: true })}
            >
              Edit Demographics Data
            </Button>
          </div>
        </div>
      }
    </Segment>);
  }
}


const fullWidth = { width: '100%' };
const InputSelect = ({ editing, value, name, options, placeholder, onChange }) => {
  const selectedOption = _.find(options, { value });
  const displayValue = _.get(selectedOption, 'text', '-');
  return (editing ? <Select
    style={fullWidth}
    placeholder={placeholder}
    name={name}
    value={value}
    options={options}
    onChange={onChange}
    clearable
  /> : <Input name={name} value={displayValue} fluid readOnly />);
};

ProfileDemographics.propTypes = {
  influencer: PropTypes.object.isRequired,
};

InputSelect.propTypes = {
  editing: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default ProfileDemographics;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-demographics.js
 **/